import type { IconSvgObject } from './types';

const ElectricPlugsIcon: IconSvgObject = [
  ["path", { d: "M6.47819 14.6082L5.35448 7.30411C5.16809 6.0926 6.10545 5 7.33122 5H16.6688C17.8945 5 18.8319 6.0926 18.6455 7.30411L17.5218 14.6082C17.2216 16.5596 15.5426 18 13.5683 18H10.4317C8.45739 18 6.77839 16.5596 6.47819 14.6082Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 8.5L10 11.5H14L12 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 2L9 5M15 2V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 18L12 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ElectricPlugsIcon;
